// extracted by mini-css-extract-plugin
module.exports = {"btnsControl":"BtnsControl_btnsControl__1WOd9","control":"BtnsControl_control__3yTYz","exit":"BtnsControl_exit__1xfVh"};